import { useState } from "react";

import Modal, { ModalProps } from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
	PregnancyByCityAndHighRiskResume,
	PregnancyByCityAndHighRiskTable,
} from "../PregnancyByCityAndHighRiskTable";
import { PregnancyByCityAndHighRiskTableFilters } from "../PregnancyByCityAndHighRiskTableFilters";

type Props = ModalProps & {
	pregnancyByCityAndHighRiskResumes: PregnancyByCityAndHighRiskResume[];
};

export function PregnancyByCityAndHighRiskModal({
	pregnancyByCityAndHighRiskResumes,
	...rest
}: Props) {
	const [cityName, setCityName] = useState("");
	const pregnancyByCityAndHighRiskResumesFiltered = pregnancyByCityAndHighRiskResumes.filter(
		(resume) => resume.city.locale.toUpperCase().includes(cityName.toUpperCase())
	);
	return (
		<Modal {...rest} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
			<Modal.Header closeButton>
				<Modal.Title>
					<h3 className="text-uppercase text-dark fw-bold fs-1">
						GESTANTES POR CIDADE E RISCO GESTACIONAL
					</h3>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="mb-4">
					<Col>
						<PregnancyByCityAndHighRiskTableFilters
							cityName={cityName}
							setCityName={setCityName}
						/>
					</Col>
				</Row>
				<PregnancyByCityAndHighRiskTable
					pregnancyByCityAndHighRiskResumes={pregnancyByCityAndHighRiskResumesFiltered}
				/>
			</Modal.Body>
		</Modal>
	);
}
